import * as imageConversion from 'image-conversion'

export default async function(file, size) {
  let blob = null
  await imageConversion.compressAccurately(file, size).then(res => {
    console.log(file, 'file')
    console.log(res, 'res')
    blob = res
  })
  const resAuatarFile = new window.File([blob], file.name, { type: file.type })
  console.log(resAuatarFile, 'resAuatarFile')
  return resAuatarFile
}
